"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _port = _interopRequireDefault(require("@/componentsBuz/Associate/port"));
var _country = _interopRequireDefault(require("@/componentsBuz/Associate/country"));
var _vessel = _interopRequireDefault(require("@/componentsBuz/Associate/vessel"));
var _vesselMain = _interopRequireDefault(require("@/componentsBuz/Associate/vesselMain"));
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _associate = _interopRequireDefault(require("@/componentsBuz/GlTabAssociate/associate.vue"));
var _route = _interopRequireDefault(require("@/componentsBuz/Associate/route"));
var _portFacility = _interopRequireDefault(require("@/componentsBuz/Associate/portFacility"));
var _portRole = _interopRequireDefault(require("@/componentsBuz/Associate/portRole"));
var _chageCode = _interopRequireDefault(require("@/componentsBuz/Associate/chageCode"));
var _cargo = _interopRequireDefault(require("@/componentsBuz/Associate/cargo"));
var _cargoGoods = _interopRequireDefault(require("@/componentsBuz/Associate/cargoGoods"));
var _shipNameVoyage = _interopRequireDefault(require("@/components/shipNameVoyage/shipNameVoyage.vue"));
var _packType = _interopRequireDefault(require("@/componentsBuz/Associate/packType"));
var _customerSipg = _interopRequireDefault(require("@/componentsBuz/Associate/customerSipg"));
var _commodity = _interopRequireDefault(require("@/componentsBuz/Associate/commodity"));
var _portConfiguration = _interopRequireDefault(require("@/componentsBuz/Associate/portConfiguration"));
var _portSimis = _interopRequireDefault(require("@/componentsBuz/Associate/portSimis.vue"));
var _voyage = _interopRequireDefault(require("@/componentsBuz/Associate/voyage.vue"));
var _index = _interopRequireDefault(require("@/componentsBuz/CheckNotice/index.vue"));
var _slideLogin = _interopRequireDefault(require("@/views/commonData/home/components/slideLogin.vue"));
function plugin(Vue) {
  Vue.component('glCountry', _country.default);
  Vue.component('glPort', _port.default);
  Vue.component('glVessel', _vessel.default);
  Vue.component('glVesselMain', _vesselMain.default);
  Vue.component('dragDialog', _DragDialog.default);
  Vue.component('glTabAssociate', _associate.default);
  Vue.component('glRoute', _route.default);
  Vue.component('glPortFacility', _portFacility.default);
  Vue.component('glPortRole', _portRole.default);
  Vue.component('glChageCode', _chageCode.default);
  Vue.component('glCargo', _cargo.default);
  Vue.component('glCargoGoods', _cargoGoods.default);
  Vue.component('GlShipVoyage', _shipNameVoyage.default);
  Vue.component('glPackType', _packType.default);
  Vue.component('glCustomerSipg', _customerSipg.default);
  Vue.component('glCommodity', _commodity.default);
  Vue.component('glPortConfiguration', _portConfiguration.default);
  Vue.component('GlPortSimis', _portSimis.default);
  Vue.component('GlVoyage', _voyage.default);
  Vue.component('CheckNotice', _index.default);
  Vue.component('slide-login', _slideLogin.default);
}
var _default = exports.default = plugin;